import Empresa from "@/domain/conta/empresa/Empresa.js";
import Table from "./Table";
export default class TableEmpresas extends Table {
    constructor() {
        super();
    }

    getHeaders() {
        var headers;
        headers = [
            { text: "Ações", value: "acoes", show: true, pesq: false, enable: false },
            { text: "CNPJ", value: "cnpj", show: true, pesq: true, enable: true },
            { text: "Razão Social", value: "razao", show: true, pesq: true, enable: true },
            { text: "Grupo", value: "grupo", show: true, pesq: false, enable: true },
            { text: "Apelido", value: "apelido", show: true, pesq: true, enable: true },
            { text: "Endereço", value: "endereco", show: true, pesq: false, enable: true },
            { text: "Bairro", value: "bairro", show: true, pesq: false, enable: true },
            { text: "Complemento", value: "complemento", show: true, pesq: false, enable: true },
            { text: "CCM", value: "ccm", show: true, pesq: false, enable: true },
            { text: "IE", value: "ie", show: true, pesq: false, enable: true },
            { text: "CEP", value: "cep", show: true, pesq: false, enable: true },
            { text: "Município", value: "municipio", show: true, pesq: false, enable: true },
            { text: "UF", value: "uf", show: true, pesq: false, enable: true },
            { text: "COD Município", value: "codMun", show: true, pesq: false, enable: true },
            { text: "Colaboradores", value: "colaboradores", show: true, pesq: false, enable: true },
            { text: "Faturamento", value: "faturamento", show: true, pesq: false, enable: true },
            { text: "Certificado", value: "certificado", show: true, pesq: false, enable: true },
            { text: "nfeTask", value: "nfeTask", show: false, pesq: false, enable: false },
            { text: "cteTask", value: "cteTask", show: false, pesq: false, enable: false },
            { text: "enviaEmails", value: "enviaEmails", show: false, pesq: false, enable: false },
            { text: "_id", value: "_id", show: false, pesq: false, enable: false },
            { text: "tknIntegracao", value: "tknIntegracao", show: false, pesq: false, enable: false },
            { text: "Data de Cadastro", value: "dtReg", show: true, pesq: false, enable: true },
            { text: "Bloqueada", value: "bloqueada", show: true, pesq: true, enable: true },
        ]
        return headers
    }

    setNota(arrayNotas, notas, faturamento, pagination) {
        let newArray = arrayNotas;
        this.loading = false;
        //pega os colaboradores ativos.
        for (var i = 0; i < notas.length; i++) {
            let colabAtivos = [];
            for (let j = 0; j < notas[i].colaboradores.length; j++) {
                if (notas[i].colaboradores[j].status) {
                    colabAtivos.push(notas[i].colaboradores[j]);
                }
            }
            newArray.push(
                new Empresa(
                    notas[i].empresa.cnpj,
                    notas[i].empresa.razao,
                    notas[i].empresa.grupo,
                    notas[i].empresa.apelido,
                    notas[i].empresa.ie,
                    notas[i].empresa.ccm,
                    notas[i].empresa.endereco,
                    notas[i].empresa.bairro,
                    notas[i].empresa.complemento,
                    notas[i].empresa.cep,
                    notas[i].empresa.municipio,
                    notas[i].empresa.uf,
                    notas[i].empresa.codMun,
                    notas[i].empresa._id == faturamento ? 'Sim' : 'Não',
                    colabAtivos,
                    notas[i].empresa.certificado,
                    notas[i].empresa.nfeTask,
                    notas[i].empresa.cteTask,
                    notas[i].empresa.enviaEmails,
                    notas[i].empresa._id,
                    notas[i].empresa.tknIntegracao,
                    notas[i].empresa.dtReg,
                    notas[i].empresa.bloqueada,

                )
            );

            if (pagination != undefined) {
                this.pagination = pagination;
            } else {
                this.pagination.sortBy = 'razao';
                this.pagination.descending = false;
            }
        }
        if(arrayNotas.length > 0) {
            arrayNotas = [ ...arrayNotas, ...newArray ];
            return arrayNotas;
        }else {
            return newArray;
        }
    }
}





// WEBPACK FOOTER //
// ./src/domain/dataTable/TableEmpresas.js